import { render, staticRenderFns } from "./LogAcessos.vue?vue&type=template&id=56ccda77"
import script from "./LogAcessos.vue?vue&type=script&lang=js"
export * from "./LogAcessos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports